// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switching-sidebar[data-v-bc775fbc]{height:calc(100% - 54px)!important}@media(min-width:600px){.switching-sidebar[data-v-bc775fbc]{height:100%!important}}.switching-sidebar__arrow[data-v-bc775fbc]{transform:rotate(180deg);margin-right:5px}.switching-sidebar__content[data-v-bc775fbc]{height:calc(100% - 48px);overflow-y:auto}@media(min-width:960px){.switching-sidebar__content[data-v-bc775fbc]{height:calc(100% - 68px)}}", ""]);
// Exports
module.exports = exports;
